import generateURL from "../../../script/url.js";
import Cookie from "js-cookie";
export {
	toSearchTopwithStock,
	goDetail,
	goItineraryDetail,
	detailParam,
	goLanding,
	post
};

function post(actionURL, params) {
	const form = document.createElement("form");
	form.action = actionURL;
	form.method = "POST";
	form.acceptCharset = "UTF-8";
	form.style.display = "none";
	document.body.appendChild(form);

	for(let key in params){
		if(params[key]) {
			const input = document.createElement("input");
			input.type = "hidden";
			input.name = key;
			input.value = params[key];
			form.appendChild(input);
		}
	}
	form.submit();
}

function toSearchTopwithStock(deptTime, contextPath) {
	const url = generateURL(contextPath);
	const actionURL = url.mobile.search;
	const param = {
		checkStock: "on",
		DEPT_TIME: deptTime.slice(-4), //MMDD
		DOMAIN: Cookie.get("jlpk-jep")
	};
	post(actionURL, param);
}

function goDetail(param, contextPath) {
	if (!contextPath) return;
	const url = generateURL(contextPath);
	const actionURL = url.mobile.detail;
	post(actionURL, {
		"DEPT": param.dept,
		"YEAR": param.year,
		"HALF": param.half,
		"COURSE_NUMBER": param.courseNumber,
		"COURSE_KEY": param.courseKey,
		"DEPT_TIME": param.yyyymmdd,
		"DOMAIN": param.domain,
		"back_hash_param": param.backHashParam,
		"directOnly": param.directOnly,
		"utm_source": param.utm_source,
		"utm_medium": param.utm_medium,
		"utm_campaign": param.utm_campaign,
		"utm_term": param.utm_term,
		"utm_content": param.utm_content,
		"121": param[121]
	});
}

function detailParam(course) {
	return {
		dept: course.departure_code,
		year: course.year,
		half: course.half,
		courseNumber: course.course_number.replace(/\s+/g, ""),
		courseKey: course.course_key
	};
}

function goItineraryDetail(store) {
	const config = store.config;
	const state = store.state;
	const url = generateURL();
	const TRANCONTROL_URL = url.mobile.trancontrol;
	const DISPATCHER_URL = url.mobile.dispatcher;
	const domain = {
		DOMAIN: Cookie.get("jlpk-jep") || "JAL.CO.JP"
	};
	const dispatcherParam = {
		memberBackUrl: TRANCONTROL_URL,
		guestBackUrl: TRANCONTROL_URL,
		memberPattern: "5,9",
		guestPattern: "5"
	};
	const mottoParam = {
		VECTOR: Cookie.get("jlpk-jep-vector"),
		DIGEST: Cookie.get("jlpk-jep-digest")
	};
	const commonParam = {
		DOMAIN: Cookie.get("jlpk-jep") || "JAL.CO.JP",
		TranID: "INT_TOURSP", // PC$B$O(BINT_TOURCOND $B6&M-$G$-$k$h$&$K$J$C$?$iJQ?t2=$7$?$[$&$,NI$$(B
		course_code: config.COURSE_NUMBER,
		dept_plac_cd: config.DEPT,
		dept_date: config.DEPT_TIME,
		pax_nm_ad: state.num.adult,
		pax_nm_ch: state.num.child,
		pax_nm_kd: state.num.kids,
		pax_nm_if: state.num.infant
	};
	const roomParam = state.priceType === "r" ? {
		rm_type_s: state.room[1],
		rm_type_t: state.room[2],
		rm_type_r: state.room[3],
		rm_type_q: state.room[4]
	} : { // priceType === "g"
		rm_type_acu: state.roomTotal,
		rm_type_acu_min: state.minUsedRoomCapacity,
		rm_type_acu_max: state.maxUsedRoomCapacity
	};

	const isMotto = mottoParam.VECTOR && mottoParam.DIGEST && Cookie.get("jlpk-jep");
	const param = isMotto ?
			Object.assign(domain, mottoParam, roomParam, commonParam):
			Object.assign(domain, dispatcherParam, roomParam, commonParam);

	const actionURL = isMotto ? TRANCONTROL_URL : DISPATCHER_URL;
	post(actionURL, param);
}

function goLanding(param, contextPath) {
	if (!contextPath) return;
	const url = generateURL(contextPath);
	const actionURL = url.mobile.landing;
	let buf = [];
	let path;
	// special
	if (param.special) {
		buf.push(param.special);
	}
	// depAirport
	if (param.depAirport) {
		buf.push(param.depAirport);
	} else {
		buf.push("ALL");
	}
	// dest0
	if (param.dest0) {
		buf.push(param.dest0);
	}

	path = actionURL + buf.join("/") + "/";

	// page
	if (param.page) {
		path += param.page + ".html";
	}

	buf = []; // re-use
	for (let key in param) {
		switch (key) {
			case "special":
			case "depAirport":
			case "dest0":
			case "page":
			case "jal_line":
				break;
			default:
				if (param[key]) {
					buf.push(key + "=" + encodeURIComponent(param[key]));
				}
				break;
		}
	}

	// query string
	if (buf.length) {
		path += "?" + buf.join("&");
	}

	post(path, param);
}



// WEBPACK FOOTER //
// ./web/WEB-INF/js/client/modules/transition.js